import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import FlagBr from '../../assets/images/signin/flag-br.svg';
import FlagUs from '../../assets/images/signin/flag-us.svg';

import * as s from './styles';

const ChangeLanguage = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  // Available languages configuration
  const languages = [
    { code: 'pt', label: 'PT', flag: FlagBr, name: 'Português' },
    { code: 'en', label: 'EN', flag: FlagUs, name: 'English' },
  ];

  const currentLangCode = i18n.language ? i18n.language.split('-')[0] : 'pt';
  const currentLang = languages.find(l => l.code === currentLangCode) || languages[0];

  const handleLanguageChange = (code: string) => {
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <>
      <s.ChangeLanguageContainer
        onClick={() => setIsOpen(true)}
        title={currentLang.name}
      >
        <img
          src={currentLang.flag}
          alt={currentLang.name}
        />
      </s.ChangeLanguageContainer>

      {isOpen && (
        <s.ModalOverlay onClick={() => setIsOpen(false)}>
          <s.ModalContent onClick={(e) => e.stopPropagation()}>
            <h3>{t('selectLanguage')}</h3>

            {languages.map((lang) => (
              <s.LanguageOption
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                active={currentLangCode === lang.code}
              >
                <img src={lang.flag} alt={lang.name} />
                <span>{lang.label}</span> - {lang.name}
              </s.LanguageOption>
            ))}

          </s.ModalContent>
        </s.ModalOverlay>
      )}
    </>
  );
};

export default ChangeLanguage;
